import { ApplicationRef, signal } from '@angular/core';

export class AppStore {

  public static readonly applicationRef = signal<ApplicationRef>(null);
  public static readonly version = signal<string>(null);
  public static shouldPreventAppReload = signal(true);
}
